(() => {
  class DigiProductStories {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector("[data-dps-carousel]");
      this.cards = [...section.querySelectorAll("[data-dps-card]")];
      this.modal = section.querySelector("[data-dps-modal]");
      this.modalContent = section.querySelector("[data-dps-modal-content]");

      this.currentIndex = 0;
      this.activeVideo = null;
      this.progressTimer = null;
      this.progressCleanup = null;
      this.isVideoPaused = false;
      this.storyTransition = 220;

      this.init();
    }

    init() {
      if (!this.section || !this.carousel || !this.cards.length) return;

      this.bindCarousel();
      this.bindCategories();
      this.bindCards();
      this.bindModal();
      this.bindVideoObserver();
      this.openFromUrl();
    }

    bindCarousel() {
      const prev = this.section.querySelector("[data-dps-carousel-prev]");
      const next = this.section.querySelector("[data-dps-carousel-next]");

      prev?.addEventListener("click", () => {
        this.carousel.scrollBy({
          left: -this.carousel.clientWidth * 0.85,
          behavior: "smooth",
        });
      });

      next?.addEventListener("click", () => {
        this.carousel.scrollBy({
          left: this.carousel.clientWidth * 0.85,
          behavior: "smooth",
        });
      });
    }

    bindCategories() {
      const buttons = [...this.section.querySelectorAll("[data-dps-category]")];

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const category = button.dataset.dpsCategory;

          buttons.forEach((item) => item.classList.remove("is-active"));
          button.classList.add("is-active");

          this.cards.forEach((card) => {
            const match = category === "all" || card.dataset.dpsCategory === category;
            card.classList.toggle("is-hidden", !match);
          });
        });
      });
    }

    bindCards() {
      this.cards.forEach((card, index) => {
        const open = card.querySelector("[data-dps-open]");
        const video = card.querySelector("video");

        open?.addEventListener("click", () => {
          this.openModal(index);
        });

        card.addEventListener("mouseenter", () => {
          if (window.matchMedia("(hover: hover)").matches) {
            this.playVideo(video);
          }
        });

        card.addEventListener("mouseleave", () => {
          if (window.matchMedia("(hover: hover)").matches) {
            this.pauseVideo(video);
          }
        });
      });
    }

    bindModal() {
        this.section.querySelectorAll("[data-dps-close]").forEach((button) => {
        button.addEventListener("click", () => {

            const sheet = this.modalContent.querySelector(
            ".digi-product-stories__modal-product-col"
            );

            const isMobile = window.matchMedia("(max-width: 989px)").matches;

            if (isMobile && sheet?.classList.contains("is-open")) {
            sheet.classList.remove("is-open");

            this.track("digi:story-shopify:shop-close", {
                entry: "overlay",
            });

            return;
            }

            this.closeModal();
        });
        });

      this.section
        .querySelector("[data-dps-modal-prev]")
        ?.addEventListener("click", () => this.goToPrevious());

      this.section
        .querySelector("[data-dps-modal-next]")
        ?.addEventListener("click", () => this.goToNext());

      document.addEventListener("keydown", (event) => {
        if (!this.modal?.classList.contains("is-open")) return;

        if (event.key === "Escape") this.closeModal();
        if (event.key === "ArrowLeft") this.goToPrevious();
        if (event.key === "ArrowRight") this.goToNext();
      });
    }

    bindVideoObserver() {
      const videos = [...this.section.querySelectorAll(".digi-product-stories__card video")];

      if (!videos.length || !("IntersectionObserver" in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.65) {
              this.playVideo(video);
            } else {
              this.pauseVideo(video);
            }
          });
        },
        {
          root: this.carousel,
          threshold: [0, 0.65, 1],
        }
      );

      videos.forEach((video) => observer.observe(video));
    }

    changeStory(index, direction = "next") {
      const grid = this.modalContent.querySelector(
        ".digi-product-stories__modal-grid"
      );

      if (!grid) {
        this.openModal(index);
        return;
      }

      grid.classList.add("is-changing");
      grid.classList.toggle("is-next", direction === "next");
      grid.classList.toggle("is-prev", direction === "prev");

      window.setTimeout(() => {
        this.openModal(index);
      }, this.storyTransition);
    }

    openModal(index) {
      const card = this.cards[index];
      const template = card?.querySelector("[data-dps-template]");

      if (!card || !template || !this.modal || !this.modalContent) return;

      this.currentIndex = index;
      this.track("digi:story-shopify:open", {
        entry: "modal",
      });
      this.pauseAllVideos();
      this.clearStoryProgress();
      this.closeMobileSheet();
      this.modalContent.innerHTML = template.innerHTML;
      this.modal.classList.add("is-open");
      this.track("digi:story-shopify:view", {
        entry: "modal",
      });
      this.modal.setAttribute("aria-hidden", "false");

      document.documentElement.classList.add("digi-product-stories-modal-open");

      this.bindModalContent();
      this.playModalVideo();
      this.bindStoryProgress();
      this.updateUrl(card.dataset.productHandle);
    }

    closeModal() {
      if (!this.modal || !this.modalContent) return;

      this.closeMobileSheet();

      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";

      this.pauseModalVideo();
      this.clearStoryProgress();
      this.resetCurrentCardState();

      this.modal.classList.remove("is-open");
      this.modal.setAttribute("aria-hidden", "true");
      this.modalContent.innerHTML = "";

      document.documentElement.classList.remove("digi-product-stories-modal-open");

      this.clearUrl();
    }

    resetCurrentCardState() {
      const card = this.getCurrentCard();
      if (!card) return;

      const video = card.querySelector("video");
      const media = card.querySelector(".digi-product-stories__video, .digi-product-stories__image");

      card.classList.remove("is-active");

      if (video) {
        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {}

        video.blur();
      }

      if (media) {
        media.style.transform = "none";

        window.requestAnimationFrame(() => {
          media.style.transform = "";
        });
      }

      this.activeVideo = null;
    }

goToPrevious() {

  const previousIndex =
    this.currentIndex <= 0
      ? this.cards.length - 1
      : this.currentIndex - 1;

  this.changeStory(previousIndex, "prev");

}

goToNext() {

  const nextIndex =
    this.currentIndex >= this.cards.length - 1
      ? 0
      : this.currentIndex + 1;

  this.changeStory(nextIndex, "next");

}

bindModalContent() {
  this.bindQuantity();
  this.bindVariants();
  this.bindGallery();
  this.bindVideoControls();
  this.bindAudioToggle();
  this.bindLike();
  this.bindShare();
  this.bindAddToCart();
  this.bindDetailsTracking();
  this.bindMobileSheet();
  this.bindStorySwipe();
}

    bindQuantity() {
      const input = this.modalContent.querySelector("[data-dps-qty]");
      const minus = this.modalContent.querySelector("[data-dps-qty-minus]");
      const plus = this.modalContent.querySelector("[data-dps-qty-plus]");

      if (!input) return;

      minus?.addEventListener("click", () => {
        const value = Math.max(1, Number(input.value || 1) - 1);
        input.value = value;
      });

      plus?.addEventListener("click", () => {
        const value = Math.max(1, Number(input.value || 1) + 1);
        input.value = value;
      });
    }

    bindVariants() {

      const wrapper = this.modalContent.querySelector(".digi-product-stories__variants");

      if (!wrapper) return;

      const optionInputs = [
        ...wrapper.querySelectorAll("[data-dps-option]")
      ];

      if (!optionInputs.length) return;

      let variants = [];

      try {
        variants = JSON.parse(wrapper.dataset.dpsVariants);
      } catch (error) {
        console.error("[DPS] Erro ao ler variantes:", error);
        return;
      }

      optionInputs.forEach((input) => {
        input.addEventListener("change", () => {

          const selectedOptions = this.getSelectedOptions();

          const variant = this.findVariantByOptions(
            variants,
            selectedOptions
          );

          if (!variant) return;

          this.syncVariantInputs(variant);
          this.updateVariant(variant);

        });
      });

    }

    getSelectedOptions() {
      const checked = [...this.modalContent.querySelectorAll("[data-dps-option]:checked")];

      return checked
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((input) => input.value);
    }

    findVariantByOptions(variants, selectedOptions) {
      return variants.find((variant) => {
        if (!variant.options || variant.options.length !== selectedOptions.length) {
          return false;
        }

        return variant.options.every((optionValue, index) => {
          return String(optionValue).trim() === String(selectedOptions[index]).trim();
        });
      });
    }

    syncVariantInputs(variant) {
      if (!variant || !variant.options) return;

      variant.options.forEach((optionValue, index) => {
        const position = index + 1;

        const input = this.modalContent.querySelector(
          `[data-dps-option][data-option-position="${position}"][value="${CSS.escape(optionValue)}"]`
        );

        if (input) {
          input.checked = true;
        }
      });
    }

    updateVariant(variant) {
      console.log(variant);
    const price = this.modalContent.querySelector("[data-dps-price]");
    const addButton = this.modalContent.querySelector("[data-dps-add]");
    this.selectedVariant = variant;
    if (price && variant.price !== undefined) {
        this.renderPrice(price, variant);
    }

    if (addButton) {
        addButton.dataset.variantId = variant.id;
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? "ADICIONAR" : "ESGOTADO";
    }

    if (variant.featured_media) {
    const mainImage = this.modalContent.querySelector(
        ".digi-product-stories__gallery-main img"
    );

    if (mainImage) {
        mainImage.src = variant.featured_media.preview_image.src;
        mainImage.removeAttribute("srcset");
    }
    }

    const currentCard = this.getCurrentCard();

    if (currentCard) {
      currentCard.dataset.variantId = variant.id;
      currentCard.dataset.productPrice = this.formatMoney(variant.price);
    }

    }

    bindGallery() {
    const main = this.modalContent.querySelector(".digi-product-stories__gallery-main");
    const mainImage = main?.querySelector("img");
    const thumbs = [...this.modalContent.querySelectorAll("[data-dps-gallery-thumb]")];

    if (!main || !mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
        const fullImage = thumb.dataset.fullImage;
        const fallbackImage = thumb.querySelector("img")?.src;

        if (!fullImage && !fallbackImage) return;

        mainImage.src = fullImage || fallbackImage;
        mainImage.srcset = "";
        mainImage.removeAttribute("srcset");

        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
        });
    });
    }
bindAddToCart() {
  const buttons = [
    ...this.modalContent.querySelectorAll("[data-dps-add], [data-dps-floating-add]")
  ];

  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      const quantityInput = this.modalContent.querySelector("[data-dps-qty]");
      const quantity = Number(quantityInput?.value || 1);

      if (!variantId) return;
      if (button.classList.contains("is-loading")) return;

      const isFloatingButton = button.hasAttribute("data-dps-floating-add");

      const variant = this.selectedVariant || null;

      const body = {
        id: Number(variantId),
        quantity,
        properties: this.getStoryCartProperties(
          isFloatingButton ? "floating-cart" : "modal"
        ),
      };

      const sellingPlan =
        variant?.selling_plan_allocations?.[0]?.selling_plan_id;

      if (sellingPlan) {
        body.selling_plan = sellingPlan;
      }

      button.disabled = true;
      button.classList.add("is-loading");

      if (isFloatingButton) {

        button
          .querySelector(".digi-product-stories__floating-spinner")
          ?.remove();

        button.insertAdjacentHTML(
          "beforeend",
          '<span class="digi-product-stories__floating-spinner"></span>'
        );

      } else {

        button.textContent = "ADICIONANDO...";

      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.description || data.message || "Erro");
        }

        await response.json();

        this.track("digi:story-shopify:add-to-cart", {
          entry: isFloatingButton ? "floating-cart" : "modal",
          quantity,
          variant_id: variantId,
        });

        if (typeof Shopify !== "undefined" && Shopify.getCart) {
          Shopify.getCart((cart) => {
            if (typeof window.updateCart === "function") {
              window.updateCart(cart);
            }

            this.updateCartBubble(cart);

            this.closeModal();

            this.openCartDrawer();
          });
        } else {
          this.dispatchCartEvents();
          this.openCartDrawer();
        }

        if (!isFloatingButton) {
          this.closeModal();

          button.textContent = "ADICIONADO";

          setTimeout(() => {
            button.disabled = false;
            button.classList.remove("is-loading");
            button.textContent = "ADICIONAR";
          }, 1200);

          return;
        }

          setTimeout(() => {
            button.disabled = false;
            button.classList.remove("is-loading");

            button
              .querySelector(".digi-product-stories__floating-spinner")
              ?.remove();

          }, 700);

      } catch (error) {
        console.error("[DPS] Erro ao adicionar:", error);

        button.disabled = false;
        button.classList.remove("is-loading");

        button
          .querySelector(".digi-product-stories__floating-spinner")
          ?.remove();

        if (!isFloatingButton) {
          button.textContent = "ERRO";
        }
      }
    });
  });
}

    bindDetailsTracking() {
    const detailsButton = this.modalContent.querySelector("[data-dps-details]");

    if (!detailsButton) return;

    detailsButton.addEventListener("click", () => {
        this.track("digi:story-shopify:view-product", {
        entry: "pdp",
        });

        sessionStorage.setItem(
        "digi_story_shopify_source",
        JSON.stringify(this.getStoryPayload("pdp"))
        );
    });
    }

    bindMobileSheet() {
      const openButton = this.modalContent.querySelector("[data-dps-shop-open]");
      const closeButton = this.modalContent.querySelector("[data-dps-shop-close]");
      const sheet = this.getMobileSheet();
      const videoArea = this.modalContent.querySelector(
        ".digi-product-stories__modal-video-col"
      );

      if (!sheet) return;

      openButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.openSheet(sheet);
      });

      closeButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.closeSheet(sheet);
      });

      videoArea?.addEventListener("click", (event) => {
        if (!sheet.classList.contains("is-open")) return;

        if (
          event.target.closest(".digi-product-stories__shop-button") ||
          event.target.closest(".digi-product-stories__floating-actions") ||
          event.target.closest(".digi-product-stories__video-action")
        ) {
          return;
        }

        this.closeSheet(sheet);
      });

      this.enableSheetDrag(sheet);
    }

    getMobileSheet() {
      return this.modalContent?.querySelector(
        ".digi-product-stories__modal-product-col"
      );
    }

    openSheet(sheet = this.getMobileSheet()) {
      if (!sheet) return;

      sheet.style.transform = "";
      sheet.classList.add("is-open");

      this.modal?.classList.add("is-sheet-open");

      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";

      this.enableSheetDrag(sheet);

      this.track("digi:story-shopify:shop-open", {
        entry: "mobile-sheet",
      });
      this.animateSheetHint(sheet);
    }

    animateSheetHint(sheet) {
      if (!sheet) return;
      if (sheet.dataset.hintPlayed === "true") return;

      const scroll = sheet.querySelector(
        ".digi-product-stories__modal-scroll"
      );

      if (!scroll) return;

      sheet.dataset.hintPlayed = "true";

      window.setTimeout(() => {
        scroll.scrollTo({
          top: 70,
          behavior: "smooth",
        });

        window.setTimeout(() => {
          scroll.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 450);
      }, 250);
    }

    closeSheet(sheet = this.getMobileSheet()) {
      if (!sheet) return;

      sheet.style.transform = "";
      sheet.classList.remove("is-open");

      this.modal?.classList.remove("is-sheet-open");

      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";

      this.track("digi:story-shopify:shop-close", {
        entry: "mobile-sheet",
      });
    }

    bindStorySwipe() {
      const container = this.modalContent;

      if (!container) return;

      let startY = 0;
      let startX = 0;

      container.addEventListener(
        "touchstart",
        (event) => {
          startY = event.touches[0].clientY;
          startX = event.touches[0].clientX;
        },
        { passive: true }
      );

      container.addEventListener("touchend", (event) => {
        const endY = event.changedTouches[0].clientY;
        const endX = event.changedTouches[0].clientX;

        const deltaY = endY - startY;
        const deltaX = endX - startX;

        if (Math.abs(deltaY) < 80) return;
        if (Math.abs(deltaX) > 60) return;

        const sheet = this.getMobileSheet();

        if (sheet?.classList.contains("is-open")) return;

        if (deltaY > 0) {
          this.goToPrevious();
        } else {
          this.goToNext();
        }
      });
    }

    closeMobileSheet() {
      const sheet = this.getMobileSheet();

      if (!sheet) return;

      sheet.style.transform = "";
      sheet.classList.remove("is-open");

      this.modal?.classList.remove("is-sheet-open");
    }

    enableSheetDrag(sheet) {
    if (!sheet || sheet.dataset.dragReady === "true") return;

    sheet.dataset.dragReady = "true";

    let startY = 0;
    let currentY = 0;
    let dragging = false;

    const header = sheet.querySelector(".digi-product-stories__sheet-close");

    if (!header) return;

    const start = (event) => {
        dragging = true;
        startY = event.touches ? event.touches[0].clientY : event.clientY;

        sheet.style.transition = "none";
    };

    const move = (event) => {
        if (!dragging) return;

        currentY = event.touches ? event.touches[0].clientY : event.clientY;

        const delta = Math.max(0, currentY - startY);
        if (!sheet.classList.contains("is-open")) return;
        sheet.style.transform = `translateY(${delta}px)`;
    };

    const end = () => {
        if (!dragging) return;

        dragging = false;

        const delta = currentY - startY;

        sheet.style.transition = "transform .28s cubic-bezier(.22,.61,.36,1)";

        if (delta > 140) {
        this.closeSheet(sheet);
        return;
        }

        sheet.style.transform = "";
    };

    header.addEventListener("touchstart", start, {
        passive: true,
    });

    header.addEventListener("touchmove", move, {
        passive: true,
    });

    header.addEventListener("touchend", end);

    header.addEventListener("mousedown", start);

    document.addEventListener("mousemove", move);

    document.addEventListener("mouseup", end);
    }

    dispatchCartEvents() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));
      document.dispatchEvent(new CustomEvent("drawer:open"));

      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          document.dispatchEvent(
            new CustomEvent("cart:change", {
              detail: { cart },
            })
          );

          this.updateCartBubble(cart);
        })
        .catch(() => {});
    }

    updateCartBubble(cart) {
      const selectors = [
        ".cart-count-bubble",
        "[data-cart-count]",
        ".header__cart-count",
        ".digi-cart-count",
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((item) => {
          item.textContent = cart.item_count;
          item.classList.toggle("is-empty", cart.item_count === 0);
        });
      });
    }

    openCartDrawer() {

      const openBtn =
        document.querySelector('[data-open-cart-sidebar]') ||
        document.querySelector('[data-cart-toggle]');

      if (openBtn) {
        openBtn.click();
        return;
      }

      document.body.classList.add('open-cart-sidebar');
    }

    bindStoryProgress() {
      this.clearStoryProgress();

      const bar = this.modalContent.querySelector("[data-dps-progress-bar]");
      const video = this.modalContent.querySelector(".digi-product-stories__modal-video");

      if (!bar) return;

      bar.style.width = "0%";

      if (video) {
        const updateProgress = () => {

          if (this.isVideoPaused) return;

          if (!video.duration) return;

          const progress =
              (video.currentTime / video.duration) * 100;

          bar.style.width = progress + "%";

        };

        video.addEventListener("timeupdate", updateProgress);
        video.addEventListener("loadedmetadata", updateProgress);

        this.progressCleanup = () => {
          video.removeEventListener("timeupdate", updateProgress);
          video.removeEventListener("loadedmetadata", updateProgress);
          bar.style.width = "0%";
        };

        updateProgress();

        return;
      }

      const duration = 6000;
      const start = Date.now();

      this.progressTimer = window.setInterval(() => {
        const elapsed = Date.now() - start;
        const progress = Math.min(100, (elapsed / duration) * 100);

        bar.style.width = progress + "%";

        if (progress >= 100) {
          window.clearInterval(this.progressTimer);
          this.progressTimer = null;
        }
      }, 80);

      this.progressCleanup = () => {
        if (this.progressTimer) {
          window.clearInterval(this.progressTimer);
          this.progressTimer = null;
        }

        bar.style.width = "0%";
      };
    }

    clearStoryProgress() {
      if (typeof this.progressCleanup === "function") {
        this.progressCleanup();
      }

      if (this.progressTimer) {
        window.clearInterval(this.progressTimer);
        this.progressTimer = null;
      }

      this.progressCleanup = null;
    }    

    pauseStoryProgress() {
      this.isVideoPaused = true;
    }

    resumeStoryProgress() {
      this.isVideoPaused = false;
    }

    playVideo(video) {
      if (!video) return;

      if (this.activeVideo && this.activeVideo !== video) {
        this.pauseVideo(this.activeVideo);
      }

      video.play().catch(() => {});
      this.activeVideo = video;
    }

    pauseVideo(video) {
      if (!video) return;

      video.pause();

      if (this.activeVideo === video) {
        this.activeVideo = null;
      }
    }

    pauseAllVideos() {
      this.section.querySelectorAll("video").forEach((video) => {
        video.pause();
      });

      this.activeVideo = null;
    }

    bindVideoControls() {
      const video =
        this.modalContent.querySelector(".digi-product-stories__modal-video");

      if (!video) return;

      video.addEventListener("click", () => {

        if (video.paused) {
          video.play();
          this.resumeStoryProgress();
          this.isVideoPaused = false;
        } else {
          video.pause();
          this.pauseStoryProgress();
          this.isVideoPaused = true;
        }
      });
    }


    bindAudioToggle(){

    const button =
    this.modalContent.querySelector("[data-dps-toggle-audio]");

    const video =
    this.modalContent.querySelector(".digi-product-stories__modal-video");

    if(!button || !video) return;

    const icon =
    button.querySelector("[data-dps-audio-icon]");
    
    const mutedIcon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M11 5 6 9H3v6h3l5 4V5Z"/>
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M22 2 2 22"/>
    </svg>
    `;

    const soundIcon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M11 5 6 9H3v6h3l5 4V5Z"/>
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M15.5 8.5a5 5 0 0 1 0 7"/>
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M18 6a8 8 0 0 1 0 12"/>
    </svg>
    `;

    icon.innerHTML = video.muted ? mutedIcon : soundIcon;

    button.setAttribute(
      "aria-label",
      video.muted ? "Ativar áudio" : "Desativar áudio"
    );

    button.addEventListener("click",(e)=>{

    e.stopPropagation();

    video.muted=!video.muted;

    icon.innerHTML =
    video.muted ? mutedIcon : soundIcon;

    button.setAttribute(
    "aria-label",
    video.muted ? "Ativar áudio" : "Desativar áudio"
    );

    });

    }

    bindLike() {
      const button = this.modalContent.querySelector("[data-dps-like]");
      const count = this.modalContent.querySelector("[data-dps-like-count]");

      if (!button) return;

      const card = this.getCurrentCard();

      if (!card) return;

      const key = "story-like-" + card.dataset.productHandle;
      const liked = localStorage.getItem(key) === "1";

      const baseCount = Number(count?.textContent ?? 0)

      button.classList.toggle("is-liked", liked);
      button.setAttribute("aria-pressed", liked ? "true" : "false");

      if (count) {
        count.textContent = liked ? baseCount + 1 : baseCount;
      }

      button.addEventListener("click", (event) => {
        event.stopPropagation();

        const isLiked = !button.classList.contains("is-liked");

        button.classList.toggle("is-liked", isLiked);
        button.setAttribute("aria-pressed", isLiked ? "true" : "false");

        localStorage.setItem(key, isLiked ? "1" : "0");

        if (count) {
          count.textContent = isLiked ? baseCount + 1 : baseCount;
        }

        this.track("digi:story-shopify:like", {
          entry: "modal",
          liked: isLiked,
        });
      });
    }

    bindShare() {
      const button = this.modalContent.querySelector("[data-dps-share]");

      if (!button) return;

      button.addEventListener("click", async (event) => {
        event.stopPropagation();

        const card = this.getCurrentCard();

        if (!card) return;

        const url = new URL(window.location.href);

        url.searchParams.set("story", card.dataset.productHandle);

        const shareData = {
          title: card.dataset.productTitle || document.title,
          text: "Olha esse produto!",
          url: url.toString(),
        };

        this.track("digi:story-shopify:share", {
          entry: "modal",
        });

        if (navigator.share) {
          try {
            await navigator.share(shareData);
            return;
          } catch (error) {
            return;
          }
        }

        try {
          await navigator.clipboard.writeText(shareData.url);

          button.classList.add("is-copied");
          button.setAttribute("aria-label", "Link copiado");

          setTimeout(() => {
            button.classList.remove("is-copied");
            button.setAttribute("aria-label", "Compartilhar story");
          }, 1600);
        } catch (error) {
          alert("Não foi possível copiar o link.");
        }
      });
    }

    playModalVideo() {
      const video = this.modalContent.querySelector("video");

      if (!video) return;

      video.play().catch(() => {});
    }

    pauseModalVideo() {
      const video = this.modalContent?.querySelector("video");

      if (!video) return;

      video.pause();
    }

    updateUrl(handle) {
      if (!handle || !window.history?.replaceState) return;

      const url = new URL(window.location.href);
      url.searchParams.set("story", handle);

      window.history.replaceState({}, "", url.toString());
    }

    clearUrl() {
      if (!window.history?.replaceState) return;

      const url = new URL(window.location.href);
      url.searchParams.delete("story");

      window.history.replaceState({}, "", url.toString());
    }

    openFromUrl() {
      const url = new URL(window.location.href);
      const story = url.searchParams.get("story");

      if (!story) return;

      const index = this.cards.findIndex((card) => card.dataset.productHandle === story);

      if (index >= 0) {
        setTimeout(() => this.openModal(index), 500);
      }
    }

    getCurrentCard() {
    return this.cards[this.currentIndex];
    }

    getStoryPayload(entry = "modal") {
    const card = this.getCurrentCard();

    if (!card) {
        return {
        source: "story-shopify",
        entry,
        };
    }

    return {
        source: "story-shopify",
        entry,
        story_id: card.dataset.storyId || "",
        story_index: card.dataset.storyIndex || "",
        story_category: card.dataset.storyCategory || "",
        product_id: card.dataset.productId || "",
        product_handle: card.dataset.productHandle || "",
        product_title: card.dataset.productTitle || "",
        variant_id: card.dataset.variantId || "",
    };
    }

    getStoryCartProperties(entry = "modal") {
    const payload = this.getStoryPayload(entry);

    return {
        "_digi_source": "story-shopify",
        "_digi_entry": entry,
        "_digi_story_id": payload.story_id,
        "_digi_story_index": payload.story_index,
        "_digi_story_category": payload.story_category,
        "_digi_product_handle": payload.product_handle,
    };
    }

    track(eventName, payload = {}) {
    const eventPayload = {
        event: eventName,
        ...this.getStoryPayload(payload.entry),
        ...payload,
    };

    // Google Tag Manager / GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    // Eventos internos do tema
    document.dispatchEvent(
        new CustomEvent(eventName, {
        detail: eventPayload,
        })
    );
    }

    renderPrice(priceContainer, variant) {
  if (!priceContainer || !variant) return;

  priceContainer.innerHTML = `
    ${
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? `
          <span class="digi-product-stories__modal-price-compare">
            ${this.formatMoney(variant.compare_at_price)}
          </span>
        `
        : ""
    }

    <span class="digi-product-stories__modal-price-current">
      ${this.formatMoney(variant.price)}
    </span>
  `;
}

    formatMoney(cents) {

    return new Intl.NumberFormat(
        "pt-BR",
        {
        style: "currency",
        currency: "BRL"
        }
    ).format(cents / 100);

    }
  }

  const init = () => {
    document.querySelectorAll("[data-digi-product-stories]").forEach((section) => {
      if (section.dataset.dpsInitialized === "true") return;

      section.dataset.dpsInitialized = "true";

      new DigiProductStories(section);
    });
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();